import React from 'react';

export default function MobileDesktopPreviewToggle(props) {
	// console.log('MobileDesktopPreviewToggle', props);
	return (
		<div className="MobileDesktopPreviewToggle">
			<i className="fa fa-mobile p-3" aria-hidden="true" />
			<i className="fa fa-desktop p-3" aria-hidden="true" />
		</div>
	);
}
